import Axios from "../helper/appConfig";

export const getBills = async (payload) => {
  return Axios.post("api/bills", payload);
};
